import axios from "axios";
import { Response } from "../../../shared/models/Response";
import { AssignedServices } from "../models/AssignedServices";
import { Service } from "../models/Service";
import { ServiceData } from "../models/ServiceData";
import { ServiceHeaderData } from "../models/ServiceHeaderData";
import { ServiceDataQuery } from "../models/ServiceDataQuery";
import { ServiceUpdate } from "../models/ServiceUpdate";
import { ServiceQuery } from "../models/ServiceQuery";
import { ServicePagination } from "../models/ServicePagination";

export class ServicesService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = `${process.env.VUE_APP_FORMS_API}/services`;
  }

  async assignService(service: Service): Promise<Response<string>> {
    const serviceURL = `${this.baseUrl}/assign-service`;
    const response = await axios.post(serviceURL, service);
    return response.data;
  }

  async getAssignedServices(
    user: string
  ): Promise<Response<AssignedServices[]>> {
    const serviceURL = `${this.baseUrl}/assigned/${user}`;
    const response = await axios.get(serviceURL);
    return response.data;
  }

  async getServicesByType(
    user: string,
    type?: string,
    serviceStateArray?: string,
    lastRef?: string,
    searchQuery?: string
  ): Promise<Response<ServiceHeaderData[]>> {
    const serviceURL = `${this.baseUrl}/by-type`;
    const response = await axios.get(serviceURL, {
      params: {
        type: type,
        user: user,
        serviceStateArray: serviceStateArray,
        lastRef: lastRef,
        searchQuery: searchQuery
      }
    });
    return response.data;
  }

  async getServicesByFilters(
    query: ServiceQuery
  ): Promise<Response<ServicePagination>> {
    const serviceURL = `${this.baseUrl}/by-filters`;
    const response = await axios.get(serviceURL, {
      params: query
    });
    return response.data;
  }

  async getServiceData(
    query: ServiceDataQuery
  ): Promise<Response<ServiceData>> {
    const serviceURL = `${this.baseUrl}/data`;
    const response = await axios.get(serviceURL, { params: query });
    return response.data;
  }

  async completeService(serviceId: string): Promise<Response<string>> {
    const serviceURL = `${this.baseUrl}/${serviceId}/complete`;
    const response = await axios.put(serviceURL);
    return response.data;
  }

  async getServiceById(idService: string) {
    const serviceURL = `${this.baseUrl}/by-id/${idService}`;
    const response = await axios.get(serviceURL);
    return response.data;
  }

  async updateDocument(idService: string, idDocument: string) {
    const serviceURL = `${this.baseUrl}/generate-pdf-complete/${idService}/${idDocument}`;
    const response = await axios.put(serviceURL);
    return response.data;
  }

  async updateService(idService: string, serviceUpdate: ServiceUpdate) {
    const serviceURL = `${this.baseUrl}/update-service/${idService}`;
    const response = await axios.put(serviceURL, serviceUpdate);
    return response.data;
  }

  async cancelService(serviceId: string): Promise<Response<string>> {
    const serviceURL = `${this.baseUrl}/${serviceId}/cancel`;
    const response = await axios.put(serviceURL);
    return response.data;
  }

  async updateServiceState(serviceStateId: {
    id: string;
    state: string;
  }): Promise<Response<string>> {
    const serviceURL = `${this.baseUrl}/update-state-service`;
    const response = await axios.put(serviceURL, serviceStateId);
    return response.data;
  }
}
